const topics = [
  {
    tag: '热播推荐',
    title: '久久视频热门精选',
    desc: '久久视频站内最受欢迎的影视合辑，涵盖动作、喜剧、爱情等多种类型，高清画质一网打尽。',
    img: 'https://readdy.ai/api/search-image?query=A%20warm%20cinematic%20movie%20collage%20visual%20with%20soft%20overlapping%20film%20frames%20in%20coral%20and%20amber%20tones%2C%20elegant%20abstract%20design%2C%20clean%20composition%2C%20modern%20entertainment%20media%20aesthetic%2C%20soft%20gradient%20background%20with%20warm%20lighting&width=800&height=500&seq=carousel-01&orientation=landscape',
    alt: '久久视频热门精选',
  },
  {
    tag: '最新上线',
    title: '芒果视频独家片单',
    desc: '芒果视频最新上线的独家内容与热门综艺，第一时间更新，免费全集在线流畅观看。',
    img: 'https://readdy.ai/api/search-image?query=A%20warm%20toned%20abstract%20entertainment%20visual%20with%20flowing%20geometric%20shapes%20in%20soft%20coral%20and%20gold%20colors%2C%20modern%20streaming%20platform%20aesthetic%2C%20clean%20minimalist%20design%2C%20elegant%20atmosphere%20with%20depth&width=800&height=500&seq=carousel-02&orientation=landscape',
    alt: '芒果视频独家片单',
  },
  {
    tag: '经典回顾',
    title: '97视频怀旧剧场',
    desc: '97视频经典影视专区，收录那些年我们追过的老剧老片，高清修复版重温青春记忆。',
    img: 'https://readdy.ai/api/search-image?query=An%20abstract%20nostalgic%20cinema%20visual%20with%20soft%20vintage%20film%20texture%20in%20warm%20sepia%20and%20coral%20tones%2C%20elegant%20geometric%20overlay%2C%20modern%20minimalist%20design%2C%20emotional%20atmosphere&width=800&height=500&seq=carousel-03&orientation=landscape',
    alt: '97视频怀旧剧场',
  },
  {
    tag: '热播排行',
    title: '丝瓜视频人气榜单',
    desc: '丝瓜视频实时热门排行，根据播放量与用户互动数据智能排序，帮你快速发现好看内容。',
    img: 'https://readdy.ai/api/search-image?query=A%20modern%20trending%20content%20visual%20with%20warm%20amber%20and%20coral%20gradient%20background%2C%20abstract%20data%20visualization%20elements%2C%20clean%20streaming%20platform%20design%20aesthetic%2C%20soft%20glowing%20lights&width=800&height=500&seq=carousel-04&orientation=landscape',
    alt: '丝瓜视频人气榜单',
  },
  {
    tag: '新片速递',
    title: '院线大片抢先看',
    desc: '及时更新国内外院线热门影片，不用去电影院也能在家享受超清画质的观影体验。',
    img: 'https://readdy.ai/api/search-image?query=A%20cinematic%20theater%20inspired%20abstract%20visual%20with%20warm%20golden%20and%20soft%20red%20tones%2C%20elegant%20curved%20shapes%2C%20modern%20premium%20design%2C%20soft%20dramatic%20lighting%2C%20high%20quality%20editorial%20style&width=800&height=500&seq=carousel-05&orientation=landscape',
    alt: '院线大片抢先看',
  },
  {
    tag: '高分推荐',
    title: '豆瓣高分影视合集',
    desc: '精选豆瓣评分8.0以上的优质电影和电视剧，节省筛选时间，直接看好片不看烂片。',
    img: 'https://readdy.ai/api/search-image?query=An%20elegant%20curated%20collection%20visual%20with%20warm%20coral%20and%20amber%20abstract%20shapes%2C%20star%20rating%20motif%2C%20modern%20minimalist%20design%2C%20premium%20editorial%20aesthetic%2C%20soft%20warm%20lighting&width=800&height=500&seq=carousel-06&orientation=landscape',
    alt: '豆瓣高分影视合集',
  },
];

export default function Carousel() {
  return (
    <section id="carousel" className="py-16 md:py-24 bg-background-50">
      <div className="px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold font-serif text-foreground-950 mb-3">
            焦点专题
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            精选热门影视专题，总有一个合你口味
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {topics.map((item, idx) => (
            <div
              key={idx}
              className="group rounded-xl overflow-hidden bg-white border border-background-200/70 hover:border-primary-200 transition-all duration-300"
            >
              <div className="relative overflow-hidden h-52">
                <img
                  src={item.img}
                  alt={item.alt}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 rounded-full bg-primary-500/90 text-white text-xs font-medium">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-5">
                <h3 className="text-base font-semibold text-foreground-950 mb-2 font-serif">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}